import { FC } from "react";
import { IPropertyChange } from "../../interfaces/endpoints/IEntityChangeLog.types";
import { labelForColumn } from "./changeHistoryLabels";

type Format = (column: string, value: unknown) => string;

interface IChangesTable {
  entityName: string;
  changes: [string, IPropertyChange][];
  format: Format;
  // Created rows have no "before"; the table then shows a single value column.
  createdOnly?: boolean;
}

// Field / before / after, in plain language.
export const ChangesTable: FC<IChangesTable> = ({ entityName, changes, format, createdOnly = false }) => (
  <div className="overflow-x-auto mb-5">
    <table className="w-full text-left border border-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-3 py-2 font-medium">Fusha</th>
          {!createdOnly && <th className="px-3 py-2 font-medium">Para</th>}
          <th className="px-3 py-2 font-medium">{createdOnly ? "Vlera" : "Pas"}</th>
        </tr>
      </thead>
      <tbody>
        {changes.map(([column, change]) => (
          <tr key={column} className="border-t border-gray-100">
            <td className="px-3 py-2" title={column}>
              {labelForColumn(entityName, column)}
            </td>
            {!createdOnly && (
              <td className="px-3 py-2 break-all text-gray-500 line-through decoration-gray-300">
                {format(column, change.Old)}
              </td>
            )}
            <td className="px-3 py-2 break-all font-medium">{format(column, change.New)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

interface IStateList {
  entityName: string;
  entries: [string, unknown][];
  format: Format;
}

// Every field of the entity as it was, as a two-column list.
export const StateList: FC<IStateList> = ({ entityName, entries, format }) => (
  <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1 mt-2 text-sm">
    {entries.map(([column, value]) => (
      <div key={column} className="flex justify-between gap-4 border-b border-gray-100 py-1">
        <dt className="text-gray-500" title={column}>
          {labelForColumn(entityName, column)}
        </dt>
        <dd className="text-right break-all">{format(column, value)}</dd>
      </div>
    ))}
  </dl>
);
